// Helper function to get padding
const getTextfieldFontSize = size => {
  switch (size) {
    case 'small':
      return '12px'
    case 'large':
      return '15px'
    case 'medium':
    default:
      return '14px'
  }
}

export default getTextfieldFontSize
